import { Grid, Box } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";
import Login from "../Login";
import { useParams } from 'react-router-dom';
import GetBasket from "../../components/GetBasket/GetBasket";

import { useState, useEffect } from "react";


const SiteLayout = styled(Grid)(({ theme }) => ({
  background: `url('/assets/Skiing-Image-QQF.jpg')`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  padding: '0 16px',
  [theme.breakpoints.up("sm")]: {
    padding: '0 32px',
  },
  [theme.breakpoints.up("md")]: {
    padding: '0 64px',
  },
  [theme.breakpoints.up("lg")]: {
    padding: '0 100px',
  },
}));





const SiteLayoutContent = styled(Box)(({ theme }) => ({
  padding: "24px",
  margin: "16px 0",
  minHeight: "222px",
  background: "#fff",
  borderRadius: "10px",
  display: "block",
}));

export default function LoginContainer() {
    const { id } = useParams();
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [isGetBasketLoading, setIsGetBasketLoading] = useState(true);
  
    useEffect(() => {
      // If there is no ID, we don't need to load GetBasket, so we set loading to false
      if (!id) {
        setIsGetBasketLoading(false);
      }
    }, [id]);
  
    const handleGetBasketLoadingChange = (isLoading) => {
      setIsGetBasketLoading(isLoading);
    };
  
    return (
      <SiteLayout container>
        {id && <GetBasket apiBaseUrl={apiBaseUrl} id={id} onLoadingChange={handleGetBasketLoadingChange} />}
        {(!id || !isGetBasketLoading) && (
          <Grid item xs={12}>
            <SiteLayoutContent>
              <Login />
            </SiteLayoutContent>
          </Grid>
        )}
      </SiteLayout>
    );
  }
